import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {translate} from 'react-i18next';
import * as usersService from '../services/users';
import withAuthentication from '../withAuthentication';
import Modal from './Modal';
import Snackbar from '../Snackbar';

class UserModal extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {

            code: '',
            email: '',
            step: props.auth.user ? 2 : 0,
            updatedUser: {},
        };

        this.focusRef = React.createRef();
        this.formRef = React.createRef();

        this.handleAssociateClick = this.handleAssociateClick.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLogoutClick = this.handleLogoutClick.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerifyClick = this.handleVerifyClick.bind(this);
    }

    afterRender() {

        if (this.props.show && this.focusRef.current)
            this.focusRef.current.focus();
    }

    componentDidMount() {

        this.afterRender();
    }

    componentDidUpdate() {

        if (this.props.auth.user && this.state.step !== 2) this.setState({step: 2});
        if (!this.props.auth.user && this.state.step >= 2) this.setState({step: 0});

        this.afterRender();
    }

    getUser() {

        return Object.assign({}, this.props.auth.user, this.state.updatedUser);
    }

    async handleAssociateClick(e) {

        e.preventDefault();

        if (this.formRef.current.checkValidity()) {

            this.formRef.current.classList.remove('was-validated');

            let user;

            try {

                user = await usersService.validate({

                    email: this.state.email,
                    code: this.state.code,
                    device: this.props.auth.device,

                }).then(result => result.item);
            }
            catch (ex) {

                Snackbar.show({message: this.props.t('modals.userModal.codeIncorrect')});
                return;
            }

            this.setState({code: ''});
            this.props.auth.setUser(user);
        }
        else
            this.formRef.current.classList.add('was-validated');
    }

    handleCodeChange(e) {

        this.setState({code: e.target.value});
    }

    handleEmailChange(e) {

        this.setState({email: e.target.value});
    }

    handleInputChange(e) {

        const target = e.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState((prevState, props) => ({

            updatedUser: Object.assign({}, prevState.updatedUser, {

                [name]: value,
            }),
        }));
    }

    handleLogoutClick() {

        this.props.auth.setUser(null);
    }

    async handleSaveClick(e) {

        e.preventDefault();

        if (this.formRef.current.checkValidity()) {

            this.formRef.current.classList.remove('was-validated');

            await usersService.updateByAuthenticated(Object.assign({}, this.getUser(), {

                device: this.props.auth.device,
            }));

            this.props.auth.setUser(this.getUser());

            if (this.props.onClose)
                this.props.onClose();
        }
        else
            this.formRef.current.classList.add('was-validated');
    }

    handleSubmit(e) {

        e.preventDefault();

        switch (this.state.step) {

            case 0:
                return this.handleVerifyClick(e);
            case 1:
                return this.handleAssociateClick(e);
            case 2:
                return this.handleSaveClick(e);
            default:
                return;
        }
    }

    async handleVerifyClick(e) {

        e.preventDefault();

        if (this.formRef.current.checkValidity()) {

            this.formRef.current.classList.remove('was-validated');

            await usersService.save({

                email: this.state.email,
                device: this.props.auth.device,
            });

            this.setState((prevState, props) => ({

                step: prevState.step + 1,
            }));

            Snackbar.show({message: this.props.t('modals.userModal.emailSent')});
        }
        else
            this.formRef.current.classList.add('was-validated');
    }

    render() {

        const {t} = this.props;
        const user = this.getUser();

        const footer = (

            <Fragment>
                {this.state.step === 0 && <button type="submit" form="user-modal" className="btn btn-primary">{t('modals.userModal.verify')}</button>}
                {this.state.step === 1 && <button type="submit" form="user-modal" className="btn btn-primary">{t('modals.userModal.associate')}</button>}
                {this.state.step === 2 && <button type="button" form="user-modal" className="btn btn-light" onClick={this.handleLogoutClick}>{t('modals.userModal.logout')}</button>}
                {this.state.step === 2 && <button type="submit" form="user-modal" className="btn btn-primary">{t('modals.userModal.save')}</button>}
            </Fragment>
        );

        let title;

        if (this.state.step === 0) title = t('modals.userModal.titleStep0');
        if (this.state.step === 1) title = t('modals.userModal.titleStep1');
        if (this.state.step === 2) title = t('modals.userModal.titleStep2');

        return (

            <Modal show={this.props.show} title={title} footerChildren={footer} onClose={this.props.onClose}>

                <form ref={this.formRef} id="user-modal" className="needs-validation" noValidate onSubmit={this.handleSubmit}>
                    {this.state.step === 0 && (

                        <input ref={this.focusRef} type="email" className="form-control" placeholder={t('modals.userModal.emailPlaceholder')} required value={this.state.email} onChange={this.handleEmailChange}/>
                    )}
                    {this.state.step === 1 && (

                        <input ref={this.focusRef} type="text" className="form-control" placeholder={t('modals.userModal.codePlaceholder')} required value={this.state.code} onChange={this.handleCodeChange}/>
                    )}
                    {this.state.step === 2 && (

                        <Fragment>
                            <Link to="/manage" className="d-block mb-3"><i className="fas fa-images mr-2"/>{t('modals.userModal.managePhotos')}</Link>
                            <input ref={this.focusRef} type="text" name="displayName" className="form-control" placeholder={t('modals.userModal.displayNamePlaceholder')} value={user.displayName} onChange={this.handleInputChange}/>
                            <input type="email" className="form-control mt-3" value={user.email} readOnly/>
                            <div className="custom-control custom-checkbox mt-3">
                                <input id="user-modal-allow-mailing" type="checkbox" name="allowMailing" className="custom-control-input" checked={user.allowMailing} onChange={this.handleInputChange}/>
                                <label htmlFor="user-modal-allow-mailing" className="custom-control-label">{t('modals.userModal.allowMailing')}</label>
                            </div>
                        </Fragment>
                    )}
                </form>

            </Modal>
        );
    }
}

export default withAuthentication(translate()(UserModal));



// WEBPACK FOOTER //
// ./src/components/modals/UserModal.js